import type { QuoteMultiplier } from "../Store/entities/multipliers/types";

type QuotePricingContextArgs = {
	dealerId?: number | null | undefined;
	distributorId?: number | null | undefined;
	multipliers?: {
		list?: QuoteMultiplier[];
	} | null | undefined;
};

const fallbackMultiplier: QuoteMultiplier = {
	name: "My Price",
	multiplier: 1,
	currency_multiplier: 1,
	currency: "USD",
	label: "My Price",
	useCoupons: true,
};

const findMultiplier = (name: string, list: QuoteMultiplier[] = []) =>
	list.find((item) => item.name === name);

const getEffectivePricingMultiplier = ({
	dealerId,
	distributorId,
	multipliers,
}: QuotePricingContextArgs): QuoteMultiplier => {
	const list = multipliers?.list ?? [];
	const isDealer = (dealerId ?? 0) !== 0;
	const isDistributor = !isDealer && (distributorId ?? 0) !== 0;

	if (isDistributor) {
		return findMultiplier("Distributor Price", list) ?? fallbackMultiplier;
	}

	if (isDealer) {
		return findMultiplier("Dealer Price", list)
			?? findMultiplier("My Price", list)
			?? fallbackMultiplier;
	}

	return findMultiplier("My Price", list)
		?? findMultiplier("Dealer Price", list)
		?? findMultiplier("Distributor Price", list)
		?? findMultiplier("buy", list)
		?? fallbackMultiplier;
};

export default getEffectivePricingMultiplier;
